import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronLeft } from 'react-icons/fi';
import './BackButton.css';

// iOS-style back control for AppTopBar's `back` slot -- a chevron only,
// no label, inside a round 44px tap target (same size as NavMenu's own
// hamburger button, see NavMenu.css) with a transparent background so
// it reads as a circular icon button rather than a solid shape, while
// still meeting the platform-standard ~44px minimum touch target even
// without text to pad it out.
//
// Exactly one of `to`/`onClick` is ever passed by a caller: `to`
// renders a Link (Leads/Analytics, and EditProfile's own profile-view
// case); `onClick` renders a plain button (EditProfile's Settings-view
// case, a local-state toggle, not navigation). Which one a given page
// uses is that page's own back semantics, unchanged by this restyle --
// see AppTopBar.js's own comment on why `back` stays a slot rather than
// a backTo/onBack prop.
const BackButton = ({ to, onClick }) => {
  if (to) {
    return (
      <Link to={to} className="back-button" aria-label="Back">
        <FiChevronLeft className="back-button__icon" />
      </Link>
    );
  }

  return (
    <button type="button" className="back-button" onClick={onClick} aria-label="Back">
      <FiChevronLeft className="back-button__icon" />
    </button>
  );
};

export default BackButton;
